import React, { useState } from 'react';
import { HiOutlinePlus, HiOutlineTrash } from 'react-icons/hi2';

const WorkPermitStep4Personnel = ({ formData, handleArrayChange, users }) => {
  const personnel = JSON.parse(formData.personnelJson || '[]');
  const [newPerson, setNewPerson] = useState({ userId: '', role: '' });

  
  const addPerson = () => {
    if (!newPerson.userId) return;
    handleArrayChange('personnelJson', [
      ...personnel,
      { userId: parseInt(newPerson.userId, 10), role: newPerson.role || 'Worker', briefed: false, signedOff: false },
    ]);
    setNewPerson({ userId: '', role: '' });
  };

  const removePerson = (idx) => {
    const copy = [...personnel];
    copy.splice(idx, 1);
    handleArrayChange('personnelJson', copy);
  };

  const userName = (id) => users.find((u) => u.userId === id)?.fullName || `User ${id}`;

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">4. Personnel & Roles</h3>
      <div className="array-field-container">
        {personnel.length === 0 && <p>No personnel assigned yet.</p>}
        {personnel.map((p, idx) => (
          <div key={idx} className="form-row">
            <span style={{ flex: 2 }}>{userName(p.userId)}</span>
            <input
              type="text"
              value={p.role}
              onChange={(e) => {
                const copy = [...personnel];
                copy[idx].role = e.target.value;
                handleArrayChange('personnelJson', copy);
              }}
              placeholder="Role"
            />
            <button type="button" className="btn-icon-delete" onClick={() => removePerson(idx)}>
              <HiOutlineTrash />
            </button>
          </div>
        ))}
        <div className="form-row">
          <div className='form-group'> 
          <select value={newPerson.userId} onChange={(e) => setNewPerson((prev) => ({ ...prev, userId: e.target.value }))}>
            <option value="">Select person</option>
            {users.map((u) => (
              <option key={u.userId} value={u.userId}>
                {u.fullName}
              </option>
            ))}
          </select>
          </div>
          <div className='form-group'>
          <input
            type="text"
            value={newPerson.role}
            onChange={(e) => setNewPerson((prev) => ({ ...prev, role: e.target.value }))}
            placeholder="Role"
          />
          </div>
          <div className='form-group wd50'>
          <button type="button" className="btn-primary wd50size" onClick={addPerson}>
            <HiOutlinePlus />
          </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkPermitStep4Personnel;

